import clsx from "clsx"

export type IconButtonSize = "small" | "medium" | "large"

export interface IconButtonProps
  extends React.HTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  size: IconButtonSize
}

const IconButton = ({
  children,
  size,
  className,
  ...other
}: IconButtonProps) => {
  return (
    <button
      className={clsx(
        {
          "h-2": size === "small",
          "h-3": size === "medium",
          "h-4": size === "large",
        },
        className
      )}
      {...other}
    >
      {children}
    </button>
  )
}

IconButton.defaultProps = {
  size: "medium",
}

export default IconButton
